import axios from 'axios'

const loadFile = async function (path) {
    let text;
    await axios.get(path).then(res => {
        text = res;
    })
    return text
}

/**
 *  文件下载
 * @param downloadUrl   文件
 * @param fileName      文件名
 */
const fileDownload = function (downloadUrl,fileName) {
    let aLink = document.createElement("a");
    aLink.style.display = "none";
    aLink.href = downloadUrl;
    aLink.download = fileName;
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
}

const base64toFile = function (base64, fileName) {
    let arr = base64.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName,{ type: mime });
}

/**
 * 图片文件压缩
 * @param file  文件
 * @param scale   压缩比例
 */

const compressImage = function (file,scale) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            const image = new Image();
            image.src = e.target.result;
            image.onload = function () {
                const width = image.width*0.7;
                const height = image.height*0.7;
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(image, 0, 0, width, height);
                canvas.toBlob( (blob) => {
                    if (blob) {
                        resolve(new File([blob], file.name, { type: file.type }));
                    } else {
                        reject(new Error('压缩失败'));
                    }
                }, file.type || 'image/png',scale);
            }
            image.onerror = function () {
                reject(new Error('Could not load image'));
            };
        }
        reader.onerror = function (error) {
            reject(error);
        };
    })
}

export {fileDownload, base64toFile, loadFile,compressImage}
